import React from 'react';
import { Button, Modal } from 'react-bootstrap';
import { FiAlertTriangle } from 'react-icons/fi';

const moeda = valor => Number(valor || 0).toLocaleString('pt-BR', {
  style: 'currency',
  currency: 'BRL',
});

// Modal exibido quando o valor/hora informado no fechamento diverge do cadastrado
// para o prestador. Devolve a ação escolhida via onSelecionar:
//   'fechar'  -> cancela; o fechamento NÃO é salvo
//   'lancar'  -> lança o fechamento com o valor/hora informado, sem alterar o cadastro
//   'alterar' -> lança o fechamento e atualiza o valor/hora no cadastro do prestador
const ModalConfirmacaoValorHora = ({
  show,
  valorInformado,
  valorVigente,
  onSelecionar,
}) => (
  <Modal
    show={show}
    onHide={() => onSelecionar('fechar')}
    dialogClassName="hpj-modal-confirma-vh"
    centered
    backdrop="static"
    keyboard={false}
  >
    <Modal.Header closeButton className="border-0" />
    <Modal.Body className="text-center">
      <div className="d-flex justify-content-center mb-2">
        <FiAlertTriangle size={56} color="#f0ad4e" />
      </div>
      <h2 className="mb-2 fw-bold">Valor/hora diferente do cadastro</h2>
      <p className="text-secondary mb-4" style={{ lineHeight: 1.5 }}>
        O valor/hora informado ({moeda(valorInformado)}) é diferente do
        cadastrado para o prestador ({moeda(valorVigente)}). Como deseja
        prosseguir?
      </p>
      <div className="hpj-confirma-vh-acoes">
        <Button variant="outline-secondary" onClick={() => onSelecionar('fechar')}>
          Fechar
        </Button>
        <Button variant="outline-primary" onClick={() => onSelecionar('lancar')}>
          Lançar sem alterar
        </Button>
        <Button variant="success" onClick={() => onSelecionar('alterar')}>
          Alterar no cadastro
        </Button>
      </div>
    </Modal.Body>
  </Modal>
);

export default ModalConfirmacaoValorHora;
